var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31062 3.24254C8.15284 2.61139 8.6302 2 9.28077 2H14.7192C15.3698 2 15.8471 2.61139 15.6894 3.24254L15.1894 5.24254C15.0781 5.6877 14.6781 6 14.2192 6H9.78077C9.3219 6 8.92192 5.6877 8.81062 5.24254L8.31062 3.24254Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88865 7.3357L8.07698 17.0756C8.02813 17.6619 8.23987 18.2399 8.65586 18.6559L11.2928 21.2929C11.6834 21.6834 12.3165 21.6834 12.7071 21.2929L15.344 18.6559C15.76 18.2399 15.9718 17.6619 15.9229 17.0756L15.1113 7.33569C14.8325 7.44225 14.5313 7.50004 14.2192 7.50004H9.78073C9.46861 7.50004 9.1674 7.44225 8.88865 7.3357Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/tie.5fcf7805efbadc593026208b86983f73.svg";
export { ForwardRef as ReactComponent };